import { useBunker } from '@/providers/BunkerProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Group, SimpleGrid, Stack, type StackProps, Text } from '@mantine/core';
import { BunkerEquipCard } from './BunkerEquipCard';
import { bunkerEquipData } from './data';
export const BunkerEquipSection: React.FC<StackProps> = ({
  ...props
}) => {
  const {
    setSelectedPart
  } = useBunker();
  const {
    i18n
  } = useLingui();
  return <Stack {...props}>
      <Group justify="space-between">
        <Box>
          <Text fz="xs" c="var(--text-prime)" tt="uppercase" fw={700}>
            {i18n._('PRIMEORB')}
          </Text>
          <Text fz={{
          base: 21,
          sm: 24,
          lg: 32
        }} className={gunterzBold.className} c="var(--text-white)">
            {'#1477'}
          </Text>
        </Box>

        <Box>
          <Text fz="xs" c="var(--text-prime)" tt="uppercase" fw={700} ta="center">
            {i18n._('LEVEL')}
          </Text>
          <Text fz={{
          base: 21,
          sm: 24,
          lg: 32
        }} className={gunterzBold.className} c="var(--text-white)" ta="center">
            {2}
          </Text>
        </Box>

        <Box>
          <Text fz="xs" c="var(--text-prime)" tt="uppercase" fw={700} ta="right">
            {i18n._('RARITY INDEX')}
          </Text>
          <Text fz={{
          base: 21,
          sm: 24,
          lg: 32
        }} className={gunterzBold.className} c="var(--text-white)" ta="right">
            {711}
          </Text>
        </Box>
      </Group>

      <SimpleGrid cols={{
      base: 2,
      sm: 1
    }} spacing={10}>
        {bunkerEquipData.map(item => <BunkerEquipCard key={item.part} handleClick={() => setSelectedPart(item)} {...item} />)}
      </SimpleGrid>
    </Stack>;
};